import { render, staticRenderFns } from "./UserOwn.vue?vue&type=template&id=d760a630&scoped=true"
import script from "./UserOwn.vue?vue&type=script&lang=js"
export * from "./UserOwn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d760a630",
  null
  
)

export default component.exports